import { render } from "./FormsHandlerCard.vue?vue&type=template&id=79a70510&ts=true"
import script from "./FormsHandlerCard.vue?vue&type=script&lang=ts"
export * from "./FormsHandlerCard.vue?vue&type=script&lang=ts"

import "./FormsHandlerCard.vue?vue&type=style&index=0&id=79a70510&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__